import React, { useEffect, useState, useMemo } from 'react';
import { Link } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Select from "react-select";
import axios from 'axios';
import arrow from "../../../../images/arrow.png";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import OrderBill from '../../Catering_Management/Manage_customer/Order_Bill';
import ReactDOMServer from 'react-dom/server';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { use } from 'react';

const CorporateOrder = () => {
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [service_sttm, setServiceSTTMValue] = useState(null);
    const [showAddOnSection, setShowAddOnSection] = useState(false); // For the Add-On Services section
    const [addOnService, setAddOnService] = useState({});
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [customer, setCustomer] = useState({});
    const [categorizedItems, setCategorizedItems] = useState([]);
    const [vendors, setVendors] = useState();
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst_percentage, setGstPercentage] = useState(0);
    const [confirmCost, setConfirmCost] = useState('');
    const [gstAmount, setGstAmount] = useState(0);
    const [totalWithGst, setTotalWithGst] = useState(0);
    const [coupon, setCoupon] = useState('');
    const [couponId, setCouponId] = useState(null);
    const [couponAmount, setCouponAmount] = useState(0);
    const navigate = useNavigate();
    const [selectedOrderDate, setSelectedOrderDate] = useState(null);
    const [EndOrderDate, setEndOrderDate] = useState(null);
    const [selectedMealsPeriod, setSelectedMealsPeriod] = useState(null);
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [headCount, setHeadCount] = useState('');
    const [specialRequest, setSpecialRequest] = useState('');
    const [paymentClosingDate, setPaymentClosingDate] = useState(null);
    const [advanceAmount, setAdvanceAmount] = useState('');
    const [errors, setErrors] = useState({});
    const [units, setUnits] = useState([]);
    const [advanceAmountInput, setAdvanceAmountInput] = useState('');
    const [refundEligible, setRefundEligible] = useState(0);
    const [advancePercentage, setAdvancePercentage] = useState(0);
    const [invoiceLoading, setInvLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    // Search term for each day
    const [searchTermForDay, setSearchTermForDay] = useState({});

    // Selected items for each day (checkboxes)
    const [selected, setSelected] = useState({});

    // Quantities for each selected item per day
    const [quantities, setQuantities] = useState({});

    useEffect(() => {
        console.log("Qtys: ", quantities);
        console.log("Sel: ", selected);
        console.log(categorizedItems);
    }, [selected, quantities, categorizedItems]);

    const days = [
        "Monday", "Tuesday", "Wednesday", "Thursday",
        "Friday", "Saturday", "Sunday"
    ];

    const dayColors = {
        Monday: '#d4f0e4',    // Very light mint green (matches base green)
        Tuesday: '#f9dada',   // Soft light red/pink (matches secondary red)
        Wednesday: '#fef5d6', // Soft yellow pastel
        Thursday: '#dbe7f9',  // Light blue pastel
        Friday: '#f0e6f7',    // Light lavender
        Saturday: '#fff2e5',  // Light peach/orange
        Sunday: '#e7f9f4'     // Light aqua/mint
    };

    const [daycount, setDcount] = useState({});

    const handleServiceChange = (selectedOption, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        selectedService: selectedOption,
                        costPerUnit: selectedOption?.cost_per_unit || 0,
                        totalCost: (selectedOption?.cost_per_unit || 0) * item.quantity
                    }
                    : item
            )
        );
    };

    const handleQuantityChange = (day, item_id, value) => {
        const quantity = parseFloat(value || 0);
        setQuantities(prev => ({
            ...prev,
            [day]: {
                ...prev[day],
                [item_id]: Number(quantity.toFixed(2))
            }
        }));
    };

    const handleAddonQuantityChange = (e, index) => {
        const quantity = parseFloat(e.target.value || 0);
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        quantity,
                        totalCost: quantity * (item.costPerUnit || 0)
                    }
                    : item
            )
        );
    };

    const handleVendorChange = (selectedVendor, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, selectedVendor }
                    : item
            )
        );
    };

    const fetchitemSchedule = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);

            const list = response.data?.data;

            if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
            } else {
                setMealsPeriod([]); // fallback to empty array
            }
        } catch (error) {
            console.error('Failed to fetch Meals period:', error);
            setMealsPeriod([]); // fallback to empty array, not object
        }
    };

    const fetchAddOnService = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/addonservice/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.service,
                    vendor: item.vendor,
                    cost_per_unit: item.cost_per_unit,
                }));
                setAddOnService(formatted);
            }
        } catch (error) {
            console.error('Failed to Add On Service Type:', error);
            setAddOnService({});
        }
    };

    const fetchCustomer = async (cust_id) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_corporate_customer/get/${cust_id}`);

            if (response.data) {
                setCustomer(response.data);
                // console.log(response.data);
            } else {
                console.error('No customer data found for this ID');
                setCustomer(null); // or however you want to handle no data
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
            setCustomer(null); // clear or reset state on error
        }
    };

    const fetchItems = async (scheduleID) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_corporate_order/get_items_by_schedule/${scheduleID}`);
            if (response.data?.data) {
                setCategorizedItems(response.data.data); // <-- Proper state update
                // console.log('Fetched categorized items:', response.data.data);
            } else {
                console.error('No items found for this schedule ID');
                setCategorizedItems([]);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
            setCategorizedItems([]);
        }
    };

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const fetchVendors = async (branch_id) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_corporate_order/get_vendors/${branch_id}`);

            if (response.data?.data) {
                // Map the data to the required format
                const formattedVendors = response.data.data.map(vendor => ({
                    value: vendor.sno.toString(),             // or vendor.vendor_id if you want unique string id
                    label: vendor.vendor_businessname || 'Unknown Vendor',
                }));

                setVendors(formattedVendors);

                // Optional: console.log to check format
                // console.log('Formatted Vendors:', formattedVendors);
            } else {
                console.error('No vendors found for this branch ID');
                toast.error('Not Able to Fetch Vendors');
                setVendors([]);
            }
        } catch (error) {
            console.error('Error fetching vendors:', error);
            setVendors([]);
        }
    };

    const getGST = () => {
        axios.get(`${BaseUrl}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setGstPercentage(parseFloat(response.data.data.gst));
                    setRefundEligible(parseFloat(response.data.data.max_refund_eligible));
                    setAdvancePercentage(parseFloat(response.data.data.refund_deducted));
                } else {
                    // console.log("Unexpected API response structure:", response);
                    setGstPercentage(5);
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
                setGstPercentage(5);
            });
    }

    const fetchUnits = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/manageunit/list/active`);
            if (response.data && response.data.data) {
                setUnits(response.data.data);  // <-- this is the array you want
            } else {
                setUnits([]);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setUnits([]);
        }
    };

    const getUnitSlugName = (unitId) => {
        if (!unitId) return '';
        const idNum = Number(unitId);
        if (isNaN(idNum)) return '';
        const matchedUnit = units.find(unit => Number(unit.sno) === idNum);
        // console.log('Looking for unitId:', idNum);
        // console.log('Matched unit:', matchedUnit);
        return matchedUnit ? matchedUnit.unitslug_name : '';
    };

    useEffect(() => {
        const customerId = localStorage.getItem('selectedCustomerId');
        fetchCustomer(customerId);
        fetchAddOnService();
        fetchitemSchedule();
        fetchUnits();
        fetchVendors(branch_id);
        getGST();
    }, []);

    const handleAddOnToggle = (e) => {
        setShowAddOnSection(e.target.checked);
    };

    const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);

    const handleAddConfig = () => {
        setRawMatrial([...rawMatrial, { id: Date.now() }]);
    };

    const handleDeleteConfig = (id) => {
        setRawMatrial(rawMatrial.filter(config => config.id !== id));
    };

    const handleConfirmCostChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            setConfirmCost(value);
            const costNumber = parseFloat(value) || 0;
            const gst = (costNumber * gst_percentage) / 100;
            setGstAmount(gst);
            setTotalWithGst(costNumber + gst);
            const autoAdvance = (costNumber * advancePercentage) / 100;
            setAdvanceAmount(autoAdvance);
            setAdvanceAmountInput(autoAdvance);
        }
    };

    function getDatesForWeekday(startDate, endDate, weekdayIndex) {
        const dates = [];
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Move to first matching weekday
        while (start.getDay() !== weekdayIndex) {
            start.setDate(start.getDate() + 1);
        }

        // Add each matching date until end date
        while (start <= end) {
            dates.push(start.toISOString().split("T")[0]); // format YYYY-MM-DD
            start.setDate(start.getDate() + 7); // next week
        }

        return dates;
    }

    const selectedItems = Object.entries(selected).flatMap(([day, items]) =>
        Object.entries(items)
            .filter(([itemId, isChecked]) => isChecked)
            .map(([itemId]) => {
                const qty = quantities[day]?.[itemId] || 0;

                // Find the item details from categorizedItems
                const group = categorizedItems.find(g =>
                    g.items.some(i => i.id === Number(itemId))
                );

                const itemData = group.items.find(i => i.id === Number(itemId));

                // convert day_code (Mon=0) -> JS weekday (Mon=1)
                const jsWeekday = (days.indexOf(day) + 1) % 7;

                // Calculate delivery dates
                const deliveryDates = getDatesForWeekday(
                    selectedOrderDate,
                    EndOrderDate,
                    jsWeekday
                );

                let cost = (parseFloat(itemData.cost || 0) * qty).toFixed(2)

                return {
                    id: itemData.id,
                    name: itemData.name,
                    quantity: qty > 0 ? qty : 1,
                    quantity_unit: itemData.measurement_quantity || null,
                    unit_name: getUnitSlugName(itemData.measurement_quantity) || null,
                    category: group.category,
                    sub_category: group.sub_category,
                    cost: cost || 0,
                    day: day,
                    day_code: days.indexOf(day),
                    dates: deliveryDates // <-- NEW FIELD
                };
            })
    );

    const handleApplyClick = () => {
        if (!coupon) {
            toast.error('Coupon Code is Required.');
            return;
        }

        const filter = {
            coupon_code: coupon,
            coupon_for: 1,
        };

        axios.get(`${BaseUrl}/coupon/code`, { params: filter })
            .then(response => {
                const data = response.data.data;
                if (data) {
                    setCouponId(data.sno);

                    let discountValue = 0;
                    if (data.coupon_type === 0) {
                        // fixed amount discount
                        discountValue = parseFloat(data.coupon_value);
                    } else if (data.coupon_type === 1) {
                        // percentage discount
                        const percentage = parseFloat(data.coupon_value);
                        discountValue = confirmCost * (percentage / 100);
                    }

                    setCouponAmount(discountValue);

                    // Calculate new amount after discount
                    const discountedAmount = confirmCost - discountValue;

                    // Calculate GST on discounted amount
                    const newGstAmount = discountedAmount * (gst_percentage / 100);

                    setGstAmount(newGstAmount);

                    // Calculate new total including GST
                    const newTotal = discountedAmount + newGstAmount;

                    setTotalWithGst(newTotal);
                } else {
                    setCouponAmount(0);
                    toast.error('Coupon not valid or expired');
                    setCouponId(null);
                }
            })
            .catch(error => {
                setCouponAmount(0);
                console.error('There was an error fetching the data!', error);
                toast.error('Error fetching coupon. Please try again.');
                setCouponId(null);
            });
    };

    const validateForm = () => {
        const newErrors = {};
        const today = new Date();
        today.setHours(0, 0, 0, 0); // reset to midnight for date comparison

        // Order Date required & can't be before today
        if (!selectedOrderDate) {
            newErrors.selectedOrderDate = "Order Date is required";
        } else {
            const orderDate = new Date(selectedOrderDate);
            orderDate.setHours(0, 0, 0, 0);
            if (orderDate < today) {
                newErrors.selectedOrderDate = "Order Date cannot be before today";
            }
        }

        if (!EndOrderDate) {
            newErrors.endOrderDate = "End Date is required";
        }

        // Order Time required
        if (!service_sttm) {
            newErrors.service_sttm = "Order Time is required";
        }

        // Meals Period required
        if (!selectedMealsPeriod) {
            newErrors.selectedMealsPeriod = "Meals Period is required";
        }

        // Delivery Address required and non-empty
        if (!deliveryAddress || !deliveryAddress.trim()) {
            newErrors.deliveryAddress = "Delivery Address is required";
        }

        // Head Count must be a number > 0
        if (!headCount || isNaN(headCount) || Number(headCount) <= 0) {
            newErrors.headCount = "Please enter a valid Head Count (number > 0)";
        }

        // Payment Closing Date required and must be today or after
        if (!paymentClosingDate) {
            newErrors.paymentClosingDate = "Payment Closing Date is required";
        } else {
            const paymentDate = new Date(paymentClosingDate);
            paymentDate.setHours(0, 0, 0, 0);
            if (paymentDate < today) {
                newErrors.paymentClosingDate = "Payment Closing Date cannot be before today";
            }
        }

        // Validate checked items quantity > 0
        // Object.entries(selected).forEach(([itemId, isChecked]) => {
        //     if (isChecked) {
        //         const qty = quantities[itemId];
        //         if (!qty || isNaN(qty) || Number(qty) <= 0) {
        //             newErrors[`itemQuantity_${itemId}`] = "Please enter valid quantity (>0)";
        //         }
        //     }
        // });

        Object.entries(selected).forEach(([day, items]) => {
            Object.entries(items).forEach(([itemId, isChecked]) => {
                if (isChecked) {
                    const qty =
                        quantities[day] && quantities[day][itemId];

                    if (!qty || isNaN(qty) || Number(qty) <= 0) {
                        newErrors[`itemQuantity_${day}_${itemId}`] =
                            "Please enter valid quantity (>0)";
                    }
                }
            });
        });



        // Validate add-on services if visible
        if (showAddOnSection) {
            rawMatrial.forEach((config, idx) => {
                if (!config.selectedService) {
                    newErrors[`addOnService_${idx}`] = "Service is required";
                }
                if (config.selectedService && config.selectedService.vendor === 0 && !config.selectedVendor) {
                    newErrors[`addOnVendor_${idx}`] = "Vendor is required";
                }
                if (!config.quantity || isNaN(config.quantity) || Number(config.quantity) <= 0) {
                    newErrors[`addOnQuantity_${idx}`] = "Enter valid units (>0)";
                }
                if (
                    config.totalCost === undefined ||
                    config.totalCost === null ||
                    isNaN(config.totalCost) ||
                    Number(config.totalCost) < 0
                ) {
                    newErrors[`addOnCost_${idx}`] = "Enter valid total cost (>= 0)";
                }
            });
        }

        const parsedConfirmCost = parseFloat(confirmCost);

        if (isNaN(parsedConfirmCost) || parsedConfirmCost < 0) {
            newErrors.confirmCost = "Confirm Cost must be a positive number or zero";
        }

        const parsedAdvanceAmount = parseFloat(advanceAmountInput);


        if (
            advanceAmountInput == '' ||
            isNaN(parsedAdvanceAmount)
        ) {
            newErrors.advanceAmount = "Advance Amount is required";
        } else if (parsedAdvanceAmount < advanceAmount) {
            newErrors.advanceAmount = `Advance Amount must be ₹${advanceAmount} or more`;
        }


        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        setErrors(null);

        if (!validateForm()) {
            return;
        }

        const addOnServices = showAddOnSection
            ? rawMatrial
                .filter(config => config.selectedService)
                .map(config => ({
                    service: config.selectedService.value,
                    vendor: config.selectedVendor ? config.selectedVendor.value : null,
                    quantity: config.quantity,
                    totalCost: config.totalCost,
                }))
            : [];

        const dataToSend = {
            orderDate: new Date(selectedOrderDate).toLocaleDateString('en-CA'),
            endDate: new Date(EndOrderDate).toLocaleDateString('en-CA'),
            orderTime: new Date(service_sttm).toTimeString().slice(0, 5),
            mealsPeriod: selectedMealsPeriod.value,
            deliveryAddress: deliveryAddress.trim(),
            headCount: Number(headCount),
            specialRequest: specialRequest.trim(),
            paymentClosingDate: new Date(paymentClosingDate).toLocaleDateString('en-CA'),
            addOnService: addOnServices,
            items: selectedItems,
            advanceAmount: Number(advanceAmount),
            confirmCost: Number(confirmCost),
            coupon: coupon,
            branch_id: branch_id,
            customer_id: customer.sno,
            total: totalWithGst,
            gst: gstAmount,
            couponamount: couponAmount,
        };

        console.log("Prepared data to send:", JSON.stringify(dataToSend, null, 2));

        try {

            const user_id = parseInt(localStorage.getItem("user_id"), 10);
            const response = await fetch(`${BaseUrl}/manage_corporate_order/create_order/${user_id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (!response.ok) {
                const errorData = await response.json();
                toast.error('Failed to create order');
            }

            const result = await response.json();
            toast.success('Order created successfully!');
            navigate('/manage-corporate-customer');
        } catch (error) {
            setErrors(error.message);
        }
    };

    const selectedItemsForPrint = selectedItems.map(item => ({
        name: item.name,
        quantity: `${item.quantity} ${getUnitSlugName(item.measurement_quantity)}`,
        pricePerQty: parseFloat(item.cost).toFixed(2),
        total: (item.quantity * item.cost).toFixed(2),
    }));


    const addOnServicesForPrint = rawMatrial
        .filter(item => item.selectedService && item.quantity > 0)
        .map(item => {
            const costPerUnit = parseFloat(item.selectedService?.cost_per_unit) || 0;
            const totalCost = parseFloat(item.totalCost) || costPerUnit * item.quantity;

            // console.log('costPerUnit:', costPerUnit, 'totalCost:', totalCost);

            return {
                name: item.selectedService.label,
                quantity: item.quantity,
                costPerUnit: costPerUnit.toFixed(2),
                total: totalCost.toFixed(2),
            };
        });

    const order = {
        orderDate: selectedOrderDate ? moment(selectedOrderDate).format("DD-MM-YYYY") : "",
        orderNumber: customer.customer_name,
        totalCost: grandTotal.toFixed(2),
        confirmCost: parseFloat(confirmCost || 0).toFixed(2),
        advanceAmount: parseFloat(advanceAmount || 0).toFixed(2),
        couponAmount: parseFloat(couponAmount || 0).toFixed(2),
        gstAmount: gstAmount.toFixed(2),
        grandTotal: (parseFloat(confirmCost || 0) + gstAmount).toFixed(2),
    };


    const handlePrint = () => {
        setInvLoading(true);
        const orderData = {
            orderDate: order?.orderDate,
            orderNumber: order?.orderNumber,
            selectedItems: selectedItemsForPrint || [],
            addOnServices: addOnServicesForPrint || [],
            totalCost: order?.totalCost || 0,
            confirmCost: order?.confirmCost || 0,
            advanceAmount: order?.advanceAmount || 0,
            couponAmount: order?.couponAmount || 0,
            gstAmount: order?.gstAmount || 0,
            grandTotal: totalWithGst || 0,
            gst_percentage: gst_percentage,
        };

        // console.log('Sending orderData:', orderData);

        fetch(`${BaseUrl}/manage_order/preview_pdf`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(orderData),
        })
            .then(response => {
                if (response.headers.get('Content-Type') === 'application/pdf') {
                    return response.blob();
                }
                toast.error('PDF generation failed.');
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            })
            .catch(error => {
                console.error('Error:', error);
                toast.error('Failed to generate PDF. Please try again.');
            })
            .finally(() => setInvLoading(false));
    };

    const filteredCategories = useMemo(() => {
        if (!searchTerm.trim()) return categorizedItems;

        const lowerSearch = searchTerm.toLowerCase();

        return categorizedItems
            .map(group => {
                const filteredItems = group.items.filter(item =>
                    item.name.toLowerCase().includes(lowerSearch)
                );
                return filteredItems.length > 0
                    ? { ...group, items: filteredItems }
                    : null;
            })
            .filter(Boolean);
    }, [searchTerm, categorizedItems]);

    const itemCostMap = useMemo(() => {
        const map = {};

        filteredCategories.forEach(group => {
            group.items.forEach(item => {
                map[item.id] = item;  // store entire item (with cost)
            });
        });

        return map;
    }, [filteredCategories]);

    const calculateDayTotalAmt = (day) => {
        if (!quantities[day]) return 0;

        let total = 0;

        Object.entries(quantities[day]).forEach(([itemId, qty]) => {
            if (!qty || isNaN(qty)) return;

            const item = itemCostMap[itemId];
            if (!item) return;

            const cost = parseFloat(item.cost || 0);
            const quantity = parseFloat(qty);

            total += cost * quantity;
        });

        return total.toFixed(2);
    };

    const dayTotals = useMemo(() => {
        const totals = {};

        days.forEach(day => {
            totals[day] = calculateDayTotalAmt(day) ? Number(calculateDayTotalAmt(day)) : 0;
        });

        return totals;
    }, [quantities, selected]);

    const countWeekdaysInRange = (startStr, endStr) => {
        if (!startStr || !endStr) return null;

        const counts = {
            Monday: 0,
            Tuesday: 0,
            Wednesday: 0,
            Thursday: 0,
            Friday: 0,
            Saturday: 0,
            Sunday: 0
        };

        // Parse strings into moment objects
        let current = moment(startStr, "YYYY-MM-DD");
        const end = moment(endStr, "YYYY-MM-DD");

        if (!current.isValid() || !end.isValid()) return null;

        while (current.isSameOrBefore(end, "day")) {
            const weekday = current.format("dddd"); // "Monday", "Tuesday", etc.
            if (counts[weekday] !== undefined) {
                counts[weekday]++;
            }
            current.add(1, "day");
        }

        return counts;
    };

    useEffect(() => {
        // Raw Material Section Total
        const rawMaterialTotal = showAddOnSection
            ? rawMatrial.reduce((sum, item) => sum + (item.totalCost || 0), 0)
            : 0;

        // 1) Get day-wise totals
        const perDayTotals = dayTotals;
        let mealPlanTotal = 0;

        // 2) If date range exists → calculate based on weekday occurrences
        if (selectedOrderDate && EndOrderDate) {
            Object.entries(perDayTotals).forEach(([day, total]) => {
                const times = daycount[day] || 0;
                mealPlanTotal += total * times;
            });

        } else {
            // 3) If no date range → weekly total (sum 7 days)
            mealPlanTotal = Object.values(perDayTotals).reduce((sum, t) => sum + t, 0);
        }

        // Final Grand Total
        setGrandTotal(rawMaterialTotal + mealPlanTotal);
    }, [
        rawMatrial,
        selectedOrderDate,
        EndOrderDate,
        dayTotals,
        showAddOnSection
    ]);

    useEffect(() => {
        if (selectedOrderDate && EndOrderDate) {
            const startDate = new Date(selectedOrderDate).toLocaleDateString('en-CA');
            const endDate = new Date(EndOrderDate).toLocaleDateString('en-CA');
            const weekdayCounts = countWeekdaysInRange(startDate, endDate);
            console.log("week days count: ", weekdayCounts);
            setDcount(weekdayCounts);
        }
    }, [selectedOrderDate, EndOrderDate])

    const hasAddOnValues = rawMatrial.some(
        item => item.selectedService && item.selectedService.label
    );

    const hasSelectedItems = Object.values(selected).some(dayObj =>
        dayObj && Object.values(dayObj).some(isChecked => isChecked === true)
    );

    // ------------------ invoice loading --------------

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(255, 255, 255, 0.50)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99999,
        pointerEvents: 'auto',
    };

    const loadingTextStyle = {
        //   color: '#0d6efd',  // bootstrap's text-primary color
        fontSize: '2rem',
        marginTop: '20px',
        fontWeight: 'bold',
    };

    if (invoiceLoading) {
        return (
            <div style={overlayStyle}>
                <div className="spinner-border text-primary mt-3" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div className='text-danger' style={loadingTextStyle}>Loading...</div>
            </div>
        );
    }

    // ------------------- end loading ----------------

    const handleSelectItem = (day, itemId, isChecked) => {
        setSelected(prev => ({
            ...prev,
            [day]: {
                ...prev[day],
                [itemId]: isChecked
            }
        }));

        if (isChecked && headCount > 0) {
            const item = categorizedItems
                .flatMap(group => group.items)
                .find(i => i.id === itemId);

            if (item && item.per_person) {
                const qty = parseFloat(headCount) * parseFloat(item.per_person);
                setQuantities(prev => ({
                    ...prev,
                    [day]: {
                        ...prev[day],
                        [itemId]: Number(qty.toFixed(2))
                    }
                }));
            }
        }

        if (!isChecked) {
            setQuantities(prev => {
                const updated = { ...prev };
                if (updated[day]) {
                    delete updated[day][itemId];   // remove quantity for item
                }
                return updated;
            });
        }
    };

    const calculateDayTotal = (day) => {
        if (!quantities[day]) return 0;

        let total = 0;

        Object.values(quantities[day]).forEach(qty => {
            if (qty && !isNaN(qty)) {
                total += 1;
            }
        });

        return total;
    };

    const getFilteredCategoriesForDay = (day) => {
        const term = (searchTermForDay[day] || "").toLowerCase();

        if (!term) return filteredCategories;  // show full list when search is empty

        return filteredCategories
            .map(group => {
                const filteredItems = group.items.filter(item =>
                    item.name.toLowerCase().includes(term)
                );

                if (filteredItems.length === 0) return null;

                return {
                    ...group,
                    items: filteredItems
                };
            })
            .filter(Boolean);
    };



    return (
        <>

            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Corporate Order</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Corporate Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Customer</li>
                    </ol>
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 bg-gray-300 py-2 px-2 rounded">
                    {customer ? (
                        <div className="d-flex flex-column">
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Customer Name</span></Tooltip>} >
                                <label className='text-danger font-w500 fs-5 text-truncate w-150px'>{customer.customer_name}</label>
                            </OverlayTrigger>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Customer Mobile</span></Tooltip>} >
                                <label className='text-black font-w400 fs-7'>{customer.customer_number}</label>
                            </OverlayTrigger>
                        </div>
                    ) : (<div></div>)}
                </div>
            </div>

            <div className='row mb-2 px-3'>
                <h4 className='font-w600 text-black fs-4'>Order Details</h4>

                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-6">Meals Period<span className="required">*</span></label>
                    <Select
                        placeholder='Select Meals Period'
                        onChange={(selectedOption) => {
                            setSelectedMealsPeriod(selectedOption);
                            fetchItems(selectedOption.value);
                        }}
                        options={mealsPeriod}
                        value={selectedMealsPeriod}
                    />
                    {errors.selectedMealsPeriod && (
                        <small className="text-danger">{errors.selectedMealsPeriod}</small>
                    )}
                </div>

                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-6">Order Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                        <div className='input-group-text bg-transparent border-0 px-0'>
                            <i className='fa-solid fa-clock fs-4'></i>
                        </div>
                        <DatePicker placeholder='Select Time'
                            disableDayPicker
                            value={service_sttm}
                            onChange={setServiceSTTMValue}
                            format="HH:mm"
                            plugins={[
                                <TimePicker hideSeconds />
                            ]}
                        />
                    </div>
                    {errors.service_sttm && (
                        <small className="text-danger">{errors.service_sttm}</small>
                    )}
                </div>

                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-6">Start Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Start Date'
                            value={selectedOrderDate}
                            onChange={setSelectedOrderDate}
                            format="DD-MM-YYYY"
                            minDate={moment().add(3, 'days').toDate()}
                        />
                    </div>
                    {errors.selectedOrderDate && (
                        <small className="text-danger">{errors.selectedOrderDate}</small>
                    )}
                </div>

                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-6">End Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select End Date'
                            value={EndOrderDate}
                            onChange={setEndOrderDate}
                            format="DD-MM-YYYY"
                            minDate={moment().add(4, 'days').toDate()}
                        />
                    </div>
                    {errors.endOrderDate && (
                        <small className="text-danger">{errors.endOrderDate}</small>
                    )}
                </div>

                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-6">Head Count (in No's)<span className="required">*</span></label>
                    <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control"
                        placeholder="Enter Head Count"
                        value={headCount}
                        onChange={e => {
                            const val = e.target.value;
                            if (/^\d*$/.test(val)) {
                                setHeadCount(val);
                            }
                        }}
                    />
                    {errors.headCount && (
                        <small className="text-danger">{errors.headCount}</small>
                    )}
                </div>

                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-6">Delivery Address<span className="required">*</span></label>
                    <textarea className="form-control" placeholder="Enter Delivery Address" value={deliveryAddress} onChange={e => setDeliveryAddress(e.target.value)} />
                    {errors.deliveryAddress && (
                        <small className="text-danger">{errors.deliveryAddress}</small>
                    )}
                </div>

                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-6">Payment Closing Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Date'
                            value={paymentClosingDate}
                            onChange={setPaymentClosingDate}
                            format="DD-MM-YYYY"
                            minDate={new Date().setHours(0, 0, 0)}
                        />
                    </div>
                    {errors.paymentClosingDate && (
                        <small className="text-danger">{errors.paymentClosingDate}</small>
                    )}
                </div>

                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-6">Special Request (if Any)</label>
                    <textarea className="form-control" value={specialRequest} onChange={e => setSpecialRequest(e.target.value)} placeholder="Enter Special Request" />
                </div>
            </div>

            <hr></hr>

            {selectedMealsPeriod && selectedOrderDate && EndOrderDate && headCount && (
                <>
                    {/* list of items */}
                    <div className="px-3 py-2">

                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h4 className='font-w600 text-black m-0 fs-4'>List Of Items</h4>
                        </div>

                        <div
                            className="day-scroll-wrapper"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                overflowX: "auto",
                                gap: "20px",
                                paddingBottom: "10px",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {days.map((day) => (
                                <>
                                    {daycount[day] != 0 && (
                                        <div className="col-lg-4 col-md-6 mb-4" key={day}
                                            style={{
                                                minWidth: "350px",   // important for horizontal scroll
                                                maxWidth: "350px",
                                                display: "inline-block",
                                            }}
                                        >

                                            <div className="day-card shadow-sm border rounded-3">

                                                {/* Header */}
                                                <div className="day-card-header p-3 border-bottom d-flex justify-content-between align-items-center" style={{ backgroundColor: dayColors[day] }}>
                                                    <h5 className="m-0 fw-bold fs-5">{day} x {daycount[day]}</h5>

                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search items..."
                                                        value={searchTermForDay[day] || ""}
                                                        onChange={(e) =>
                                                            setSearchTermForDay(prev => ({
                                                                ...prev,
                                                                [day]: e.target.value
                                                            }))
                                                        }
                                                        style={{ width: "140px" }}
                                                    />
                                                </div>

                                                {/* Body */}
                                                <div className="day-card-body p-3" style={{ maxHeight: "300px", overflowY: "auto", overflowX: "hidden" }}>

                                                    {getFilteredCategoriesForDay(day).map((group, index) => (
                                                        <div key={index} className="mb-3">

                                                            <div className="fw-bold text-primary fs-6">
                                                                {group.category}
                                                                <span className="small text-dark"> ({group.sub_category})</span>
                                                            </div>

                                                            <div className="row mt-2">

                                                                {group.items.map((item) => (
                                                                    <div className="col-12 mb-2" key={item.id}>

                                                                        <div className="d-flex align-items-start">

                                                                            {/* Checkbox */}
                                                                            <input
                                                                                className="form-check-input mt-1 me-2"
                                                                                type="checkbox"
                                                                                checked={selected[day]?.[item.id] || false}
                                                                                onChange={(e) =>
                                                                                    handleSelectItem(day, item.id, e.target.checked)
                                                                                }
                                                                            />

                                                                            <div className="w-100">
                                                                                {/* Item Name */}
                                                                                <label className="form-check-label fw-medium fs-7 text-black">
                                                                                    {item.name}
                                                                                    <span className="text-black small">
                                                                                        ({getUnitSlugName(item.measurement_quantity)})
                                                                                    </span>
                                                                                </label>

                                                                                {/* Quantity Input */}
                                                                                {selected[day]?.[item.id] && (
                                                                                    <>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control form-control-sm mt-1"
                                                                                            placeholder="Quantity"
                                                                                            value={quantities[day]?.[item.id] || ""}
                                                                                            onChange={(e) =>
                                                                                                handleQuantityChange(day, item.id, e.target.value)
                                                                                            }
                                                                                        />

                                                                                        {errors[`itemQuantity_${day}_${item.id}`] && (
                                                                                            <small className="text-danger">
                                                                                                {errors[`itemQuantity_${day}_${item.id}`]}
                                                                                            </small>
                                                                                        )}
                                                                                    </>
                                                                                )}


                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                ))}

                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>

                                                {/* Footer */}
                                                <div className="day-card-footer p-3 border-top  d-flex justify-content-between" style={{ backgroundColor: dayColors[day] }}>
                                                    <span className="fw-semibold fs-5 text-black">Total Items</span>
                                                    <span className="fw-bold text-primary fs-5">
                                                        {calculateDayTotal(day)} No's
                                                    </span>
                                                </div>
                                                <div className="day-card-footer p-3 border-top  d-flex justify-content-between" style={{ backgroundColor: dayColors[day] }}>
                                                    <span className="fw-semibold fs-5 text-black">Total Amount</span>
                                                    <span className="fw-bold text-primary fs-5">
                                                        ₹ {calculateDayTotalAmt(day)}
                                                    </span>
                                                </div>

                                            </div>

                                        </div>
                                    )}
                                </>
                            ))}
                        </div>

                    </div>

                    {/* add ons check and list */}
                    <div className='px-3'>
                        <div className='row mb-2 px-3'>
                            <div className='col-lg-12 mb-2'>
                                <div className="d-flex justify-content-between align-items-center mt-3">

                                    {/* Left side - checkbox + label */}
                                    <div className="form-check custom-checkbox d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            onChange={handleAddOnToggle}
                                            className="form-check-input me-3"
                                            id="customCheckBox1"
                                            checked={showAddOnSection}
                                        />
                                        <h4 className='font-w600 text-black m-0 fs-4' htmlFor="customCheckBox1">
                                            Add-On Services
                                        </h4>
                                    </div>

                                    {/* Right side - Add More button */}
                                    {showAddOnSection && (
                                        <button className="btn btn-sm btn-primary" onClick={handleAddConfig}>
                                            <i className="fa-solid fa-plus fs-6"></i>
                                            <span className='ms-2 fs-7'>Add More</span>
                                        </button>
                                    )}

                                </div>
                            </div>

                            {showAddOnSection && (
                                <>
                                    {/* Scrollable Add-on Container */}
                                    <div
                                        className="border rounded p-3 mb-1"
                                        style={{
                                            maxHeight: "350px",   // ⬅ change height if you want
                                            overflowY: rawMatrial.length > 3 ? "auto" : "visible",
                                            overflowX: "hidden"
                                        }}
                                    >
                                        {rawMatrial.map((config, index) => (
                                            <div key={config.id} data-repeater-item className="mb-1 pb-2 ">
                                                <div className='row p-1'>
                                                    <div className='col-lg-11'>
                                                        <div className='row'>

                                                            {/* Service */}
                                                            <div className='col-lg-3 mb-2'>
                                                                <label className="text-black font-w500 fs-6">
                                                                    Service<span className="required">*</span>
                                                                </label>
                                                                <Select
                                                                    placeholder='Select Service'
                                                                    value={config.selectedService}
                                                                    onChange={(option) => handleServiceChange(option, index)}
                                                                    options={addOnService}
                                                                    menuPortalTarget={document.body}
                                                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                                />
                                                                {errors[`addOnService_${index}`] && (
                                                                    <small className="text-danger">{errors[`addOnService_${index}`]}</small>
                                                                )}
                                                            </div>

                                                            {/* Vendor (Conditional) */}
                                                            {config.selectedService?.vendor === 0 && (
                                                                <div className='col-lg-3 mb-2'>
                                                                    <label className="text-black font-w500 fs-6">
                                                                        Vendor<span className="required">*</span>
                                                                    </label>
                                                                    <Select
                                                                        placeholder='Select Vendor'
                                                                        value={config.selectedVendor}
                                                                        onChange={(option) => handleVendorChange(option, index)}
                                                                        options={vendors}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                                    />
                                                                    {errors[`addOnVendor_${index}`] && (
                                                                        <small className="text-danger">{errors[`addOnVendor_${index}`]}</small>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* Quantity */}
                                                            <div className="col-lg-3 mb-2">
                                                                <label className="text-black font-w500 fs-6">
                                                                    No Of Units<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Enter Units"
                                                                    value={config.quantity}
                                                                    onChange={(e) => handleAddonQuantityChange(e, index)}
                                                                />
                                                                {errors[`addOnQuantity_${index}`] && (
                                                                    <small className="text-danger">{errors[`addOnQuantity_${index}`]}</small>
                                                                )}
                                                            </div>

                                                            {/* Total Cost */}
                                                            <div className="col-lg-3 mb-2">
                                                                <label className="text-black font-w500 fs-6">Total Cost</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Enter Total Cost"
                                                                    value={(config.totalCost || 0).toFixed(2)}
                                                                    readOnly
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Delete Button */}
                                                    <div className="col-lg-1 mb-1 px-1 py-1 d-flex align-items-center justify-content-end align-content-center">
                                                        {rawMatrial.length > 1 && (
                                                            <button
                                                                className="btn btn-danger px-2 py-2"
                                                                onClick={() => handleDeleteConfig(config.id)}
                                                                data-bs-toggle="tooltip"
                                                                data-bs-placement="top"
                                                                title="Delete"
                                                            >
                                                                <i className="fa-solid fa-trash-can fs-6 text-white"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* selected summary & payment */}
                    <div className='row mx-2 my-1'>

                        {/* selected summary */}
                        <div className='col-lg-6'>
                            {(hasSelectedItems || hasAddOnValues) && (
                                <div className="p-4 rounded" style={{ backgroundColor: '#f0f5ef', maxHeight: '330px', overflowY: 'auto', }} id="printableArea">

                                    {/* Selected Item */}
                                    {hasSelectedItems && (
                                        <>
                                            <h5 className="text-black font-w600 mb-3 fs-4"><i className="fa-solid fa-circle-check text-primary fs-5"></i> Selected Items</h5>
                                            {/* GRID CONTAINER */}
                                            
                                            {days.map(day => {
                                                const daySelected = selected[day] || {};
                                                const dayQuantities = quantities[day] || {};

                                                // If no items selected for this day → skip UI
                                                const hasSelected = Object.values(daySelected).some(v => v === true);
                                                if (!hasSelected) return null;

                                                return (
                                                    <div key={day} className="mb-4">

                                                        {/* Day Title */}
                                                        <h6 className="fw-bold text-primary mb-2">{day} x {daycount[day]}</h6>

                                                        {/* Grid Container */}
                                                        <div
                                                            className="d-flex flex-wrap gap-3"
                                                            style={{ rowGap: "15px" }}
                                                        >
                                                            {Object.entries(daySelected).map(([itemId, isChecked]) => {

                                                                if (!isChecked) return null;

                                                                // Find item info
                                                                const item = categorizedItems
                                                                    .flatMap(group => group.items)
                                                                    .find(i => i.id.toString() === itemId.toString());

                                                                if (!item) return null;

                                                                const quantity = dayQuantities[itemId] || 0;
                                                                const totalCost = (parseFloat(item.cost || 0) * quantity).toFixed(2);

                                                                return (
                                                                    <div
                                                                        key={itemId}
                                                                        className="p-3 rounded shadow-sm bg-white"
                                                                        style={{
                                                                            width: "calc(50% - 10px)",
                                                                            border: "1px solid #e0e0e0",
                                                                        }}
                                                                    >
                                                                        <div className="fw-bold text-black fs-6">
                                                                            {item.name}
                                                                        </div>

                                                                        <div className="d-flex justify-content-between align-items-center mt-1">
                                                                            <div className="fs-6 text-black">
                                                                                {quantity} {getUnitSlugName(item.measurement_quantity)}
                                                                            </div>

                                                                            <div className="fw-bold text-primary fs-4">
                                                                                ₹ {totalCost}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </>
                                    )}

                                    {/* Optional: Add-on services summary */}
                                    {showAddOnSection && hasAddOnValues && (
                                        <>
                                            <h5 className="text-black font-w600 mb-3 fs-4 mt-3"><i className="fa-solid fa-circle-check text-primary fs-5"></i> Add-On Services</h5>

                                            <div
                                                className="d-flex flex-wrap gap-3"
                                                style={{ rowGap: "15px" }}
                                            >
                                                {rawMatrial.map((config, index) => (
                                                    config.selectedService && (
                                                        <div
                                                            key={index}
                                                            className="p-3 rounded shadow-sm bg-white"
                                                            style={{
                                                                width: "calc(50% - 10px)",
                                                                border: "1px solid #e0e0e0",
                                                            }}
                                                        >
                                                            <div className="fw-bold text-black fs-6">
                                                                {config.selectedService.label}
                                                            </div>

                                                            <div className="d-flex justify-content-between align-items-center mt-1">
                                                                <div className="fs-6 text-black">
                                                                    {config.quantity || 0} unit(s)
                                                                </div>

                                                                <div className="fw-bold text-primary fs-4">
                                                                    ₹ {(parseFloat(config.selectedService.cost_per_unit || 0) *
                                                                        (config.quantity || 0)
                                                                    ).toFixed(2)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        </>
                                    )}

                                </div>
                            )}
                        </div>

                        {/* amount section */}
                        <div className='col-lg-6'>
                            <div className='d-flex flex-column align-items-end justify-content-end py-4 px-4 rounded' style={{ backgroundColor: '#f0f5ef' }}>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">Total Cost<span className="required"></span></label>
                                        <span className='align-items-start text-black font-w500 fs-3'>{grandTotal.toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">Confirm Cost<span className="required">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Confirm Cost" style={{ width: '50%' }} value={confirmCost} onChange={handleConfirmCostChange} />
                                    </div>
                                    {errors.confirmCost && (
                                        <small className="text-danger">{errors.confirmCost}</small>
                                    )}
                                </div>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={
                                        <Tooltip className='tooltip-popover'>
                                            <span className='fs-9 text-white fw-semibold'>
                                                Based On Refund Eligible
                                            </span>
                                        </Tooltip>
                                    }
                                >
                                    <div className="col-lg-10 mb-2">
                                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                            <label className="text-black font-w500 fs-5">
                                                Advance Amount<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                className="form-control text-black"
                                                placeholder="Enter Advance Amount"
                                                style={{ width: '50%' }}
                                                value={advanceAmountInput}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setAdvanceAmountInput(value);

                                                    const parsed = parseFloat(value);
                                                    if (value === "" || isNaN(parsed)) {
                                                        setErrors(prev => ({
                                                            ...prev,
                                                            advanceAmount: "Advance Amount is required",
                                                        }));
                                                    } else if (parsed < advanceAmount) {
                                                        setErrors(prev => ({
                                                            ...prev,
                                                            advanceAmount: `Advance Amount must be ₹${advanceAmount} or more`,
                                                        }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, advanceAmount: null }));
                                                    }
                                                }}
                                            />
                                        </div>
                                        {errors.advanceAmount && (
                                            <small className="text-danger">{errors.advanceAmount}</small>
                                        )}
                                    </div>
                                </OverlayTrigger>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">
                                            Discount Coupon<span className="required"></span>
                                        </label>
                                        <div className="d-flex gap-2 w-50">
                                            <input type="text" className="form-control" placeholder="Enter Coupon" style={{ flex: 1, width: '5%' }} value={coupon} onChange={e => setCoupon(e.target.value)} />
                                            <button type="button" className="btn btn-sm btn-primary" style={{ whiteSpace: 'nowrap' }}><img src={arrow} alt='submit' onClick={handleApplyClick} /></button>
                                        </div>
                                    </div>
                                </div>
                                {couponAmount ? (
                                    <div className="col-lg-10 mb-2">
                                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                            <label className="text-black font-w500 fs-5">
                                                Coupon Amount
                                                <span className="required"></span>
                                            </label>
                                            <span className='align-items-start text-black font-w500 fs-3'>{couponAmount.toFixed(2)}</span>
                                        </div>
                                    </div>
                                ) : null}


                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">GST Amount ({gst_percentage}%)<span className="required"></span></label>
                                        <span className='align-items-start text-black font-w500 fs-3'>{gstAmount.toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-danger font-w500 fs-3">Grand Total<span className="required"></span></label>
                                        <span className='align-items-start text-red font-w500 fs-2'>{totalWithGst.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={handlePrint}  // Print trigger
                        >
                            Preview Invoice
                            <i className="fas fa-file-alt ms-2"></i>
                        </button> */}
                        <Link to={'/manage-corporate-customer'} className="btn btn-sm btn-secondary">Cancel</Link>
                        <button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            Create Order
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
                </>
            )}

        </>
    )


}
export default CorporateOrder;